import * as http from '../utils/http';
import Poi from '../models/Poi';
import City from '../models/City';
import { tantutravelHost } from '../config';


// 获取一个poi
export function getOne(poi_uid) {
  let url = '/m/v2/?m=api/poi/get_info_by_poi_uid';

  return http.get(url, {
    data: {
      poi_uids: poi_uid,
      show_tips: 1,
      append_city: 1
    }
  })
  // 数据转换
    .then(function (data) {
    // poi对象
      let poi = data.map[poi_uid];
      poi = Poi.parseInput(poi);
      // 城市对象
      let city = data.city_map[poi.info.city];
      city = City.parseInput(city);

      let result = {
        poi: poi,
        city: city
      };

      return result;
    });
}




/**
 * 获取poi的主题偏好列表
 * @param {*} trip_id  行程id
 * @param {*} tcm_id 关联城市id
 */
export function getPreference(tcm_id, trip_id) {
  let url = '/m/v2/?m=api/poi/preference/list';

  return http.get(url, {
    data: {
      tcm_id,
      trip_id,
    }
  })
  // 数据转换
    .then(function (data) {
      return data;
    });
}




/**
 * 搜索poi
 * trip_id : string , 当前行程id
 * city_ids: string , 取还车城市poiid集合
 * poi_ids: string , 当天日程的poiid集合
 * keyword: keyword, 关键字
 * p: page 分页索引
 */
export function searchPois(trip_id, city_ids, poi_uids, keyword, p) {
  let url = '/m/v2/?m=api/poi/search/comprehensive';
  return http.get(url, {
    data:{
      trip_id,
      city_ids,
      poi_uids,
      keyword,
      p
    }
  });
}


/**
 * 获取一个城市的混合类型 poi列表
 * @param {*} trip_id
 * @param {*} city_id
 * @param {*} type
 * @param {*} page_param
 */
export function getPoisByCityMixed(trip_id, city_id, type, page_param){
  let url = '/m/v2/?m=api/poi/mixed/recommend_by_city';
  return http.get(url, {
    data:{
      trip_id,
      city_id,
      type,
      page_param,
      sort: 'score'
    }
  });
}





/**
 * 1.2 版本的获取poi详情
 * @param {*} poi_uid 
 */
export function getOneNew(poi_uid) {
  let url = '/m/v2/?m=api/poi/detail/poi_uid_info_v1_2';

  return http.get(url, {
    data: {
      poi_uid: poi_uid
    }
  })
  // 数据转换
    .then(function (data) {
    // poi对象
      let poi = data;
      // // 城市对象
      let city = City.parseInput(data.city_info);

      let result = {
        poi: poi,
        city: city
      };

      return result;
    });
}






/**
 * 1.2 版本的获取poi的下一站数据
 * @param {*} poi_uid 
 */
export function getPoiNextStation(poi_uid) {
  let url = '/m/v2/?m=api/poi/next_station';

  return http.get(url, {
    data: {
      poi_uid: poi_uid
    }
  })
    .then(function (data) {
      return data;
    });
}

/**
 * 1.2 获取poi的评价列表
 * @param {*} poi_uid 
 */
export function getPoiComments(poi_uid, list_type, next_page) {
  let url = '/m/v2/?m=api/poi/comment/list';

  return http.get(url, {
    data: {
      poi_uid,
      list_type,
      next_page,
      page_size: 10
    }
  })
    .then(function (data) {
      return data;
    });
}




/**
  * 1.3 获取自定义poi点的完整poi结构
  * @param {string} cn_name	string	必填	自定义POI的中文名称
  * @param {strnumbering} lat	float	必填	纬度信息，有效精度8位
  * @param {number} lng	float	必填	经度信息，有效精度8位
  * @param {string}  trip_id	string	必填	当前对应行程的行程ID，并通过行程ID验证权限
  * @param {number} select_city_id	int	必填	选择的城市信息，此处为选择城市时的默认城市
  * @param {string} stay_time	int	必填	停留时间，单位为小时可选范围0-8
  * @param {int} need_poi_info	int	选填	是否需要返回POI的信息，默认为0，当值为1时有效
 */
export function createCustomPoi(query) {
  let url = '/m/v2/?m=api/poi/user_custom/travel/create_v1_3';

  return http.post(url, {
    data: {
      ...query,
      need_poi_info: 1
    }
  })
    .then(function (data) {
      return data;
    });
}


/**
 * 1.3 编辑自定义poi点的完整poi结构
 * @param {*} query oneof.[cn_name, lat, lng]
 */
export function updateCustomPoi(query) {
  let url = '/m/v2/?m=api/poi/user_custom/travel/update_v1_3';

  return http.get(url, {
    data: {
      ...query, 
      need_poi_info: 1
    }
  })
    .then(function (data) {
      return data;
    });
}




/**
 * 1.3 检测是否允许更新自定义poi或者自定义酒店
 * @param {*} poi_uid
 */
export function checkAllowUpdateCustomPoi(poi_uid) {
  let url = '/m/v2/?m=api/poi/user_custom/check_allow_update_v1_3';

  return http.get(url, {
    data: {poi_uid}
  })
    .then(function (data) {
      return data;
    });
}



/**
 * 1.5版本
 * 通过中间件接口获取一个城市的混合类型 poi列表
 * @param {*} trip_id
 * @param {*} city_id
 * @param {*} type
 * @param {*} page_param
 */
export function getPoisMixedByMiddleware(trip_id, city_id, type, page_param){
  let url = `${tantutravelHost}/api/poi/recommendpoisbycity`;
  return http.get(url, {
    data:{
      trip_id,
      city_id,
      type,
      page_param,
      sort: 'score'
    }
  });
}

/**
 * 从收藏夹获取poi点
 * @param {*} city_id 
 */
export function getPoisFromFavorite(city_id){
  let url = '/m/v2/?m=api/favorites/comprehensive';
  return http.get(url, {
    data:{
      city_id
    }
  })
    .then(function (data) {
      return data;
    });
}




/**
 * 1.5 版本的获取poi的详情和下一站数据
 * @param {*} poi_uid 
 */
export function getPoiDetailAndStation(poi_uid) {
  let url = `${tantutravelHost}/api/poi/detail`;

  return http.get(url, {
    data: {
      poi_uid: poi_uid
    }
  })
    .then(function (data) {
      return data;
    });
}


// WEBPACK FOOTER //
// ./src/services/poi.js